// extracted by mini-css-extract-plugin
export default {"loader":"LoadingScreen_loader__9ugaF","diamondLoader":"LoadingScreen_diamondLoader__Ew9OS"};